// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__qGKBp","ranges":"BmiRanges_ranges__1TJTN"};